export default "__VITE_ASSET__DOEZenZo__"